import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import fr from './locales/fr.json';

void i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        fr: { translation: fr },
    },
    // Language is controlled by languageStore (persisted in localStorage).
    // We start with 'fr' as a safe default; the store will call changeLanguage on hydration.
    lng: 'fr',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    showSupportNotice: false,
});

export default i18n;
